import useFetch from 'react-fetch-hook';

import { Layout, Seo } from '../components';

import { Hero, WhyWeSmall, CallToAction, About, Map, Counter, BookMove, Reviews, ContactUs } from '../sections';

const SETTINGS_URL = 'https://admin.spacemovingsf.com/wp-json/wp/v2/general_settings?slug=general-settings';

const ADMIN_URL = 'https://admin.spacemovingsf.com/wp-json/wp/v2';

const hero_title = `Rated #1 <br/>Long-Distance Movers`;

const LongDistanceMovers = () => {
  const { data, error, isLoading } = useFetch(`${ADMIN_URL}/pages?slug=long-distance-movers`);
  const settings = useFetch(SETTINGS_URL);

  if (isLoading || settings.isLoading) return;

  return (
    <Layout id="long-distance-movers">
      <Seo data={data[0]?.yoast_head_json} />
      <Hero title={hero_title} />
      <WhyWeSmall />
      <CallToAction phone={settings.data[0].acf.contacts.phone} />
      <About content={data[0]?.acf.about.content} />
      <Map />
      <Counter />
      <BookMove phone={settings.data[0].acf.contacts.phone} />
      <Reviews data={settings.data[0].acf.reviews} />
      <ContactUs phone={settings.data[0].acf.contacts.phone} />
    </Layout>
  );
};

export default LongDistanceMovers;
